import appClient from './AppClient';
import { UserBasicDetailsDto } from '../types';
import { endpoints } from '../../../config';

const DISPLAY_USERS_BATCH_SIZE = 100;

export interface DisplayUsersResult {
    users: UserBasicDetailsDto[];
    failedIds: string[];
    errors: unknown[];
}

export default class UsersService {
    async getDisplayUsers(userIds: string[]): Promise<DisplayUsersResult> {
        const users: UserBasicDetailsDto[] = [];
        const failedIds: string[] = [];
        const errors: unknown[] = [];
        for (let offset = 0; offset < userIds.length; offset += DISPLAY_USERS_BATCH_SIZE) {
            const batch = userIds.slice(offset, offset + DISPLAY_USERS_BATCH_SIZE);
            const resp = await appClient.post<UserBasicDetailsDto[]>(`${endpoints.usersUrl}display-users`, {
                userIds: batch
            });
            if (resp.isErr()) {
                failedIds.push(...batch);
                errors.push(resp.error);
                continue;
            }
            users.push(...resp.value);
        }
        return { users, failedIds, errors };
    }

    async getUsersBasicDetails(): Promise<UserBasicDetailsDto[]> {
        const url = `${endpoints.usersUrl}basic-details`;
        const resp = await appClient.get<UserBasicDetailsDto[]>(url);
        if (resp.isErr()) {
            throw resp.error;
        }
        return resp.value;
    }
}
